var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"direction":"vertical"}},[_vm._t("header"),_c('el-container',{class:[_vm.loggedIn ? 'admin' : 'side-header', 'main-content']},[_vm._t("sidebar"),_c('router-view')],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }